<div class="document-number-info">
  <span class="document-type" [hidden]="!documentType">
    {{ 'DOCUMENT.TYPE.' + documentType | uppercase | translate }}
  </span>

  <div class="document-number-wrapper">
    <span class="document-number-symbol">
      {{ 'LABEL.DOCUMENT_NUMBER_SYMBOL' | translate }}
    </span>

    <app-input-field
      *ngIf="form"
      class="document-number-field"
      [label]="'LABEL.DOCUMENT_NUMBER' | translate"
      [hideLabel]="true"
      fieldId="document_number_field"
      e2eId="document-number-field"
      [placeholder]="'PLACEHOLDER.ENTER_DOCUMENT_NUMBER' | translate"
      [fieldControl]="form.get(formKeys.DOCUMENT_NUMBER)"
      [maxlength]="19"
      (onBlur)="showDocumentNumberChangeConfirmDialog()"
    >
    </app-input-field>
  </div>
</div>

<app-document-status
  class="document-status"
  [documentType]="documentType"
  [documentState]="documentState"
  [documentCalculationResult]="documentCalculationResult"
  [featureToggles]="featureToggles"
  [showRecurringIcon]="
    (enableRecurring$ | async) && !!documentSchedule?.interval
  "
>
</app-document-status>

<div *ngIf="form" class="summary-dates aside-section">
  <div class="form-row">
    <app-date-picker-field
      [label]="'LABEL.DATE' | translate"
      fieldId="date_field"
      e2eId="date-field"
      [horizontalAlignment]="datePickerHorizontalAlignment"
      [formControl]="form.get(formKeys.DATE)"
    >
    </app-date-picker-field>
  </div>

  <div *ngIf="showDueDate" class="form-row terms-select">
    <app-select-field
      [label]="'LABEL.TERMS' | translate"
      fieldId="terms_field"
      e2eId="terms-field"
      [formControl]="form.get(formKeys.TERMS)"
      [values]="selectOptions"
      [horizontalAlignment]="termsHorizontalAlignment"
      [trackingObject]="trackingObject"
      [trackingTapped]="termsTappedAction"
      [trackingSelected]="termsSelectedAction"
    >
    </app-select-field>
  </div>

  <div *ngIf="showDueDate" class="form-row">
    <app-date-picker-field
      [label]="'LABEL.DUE_DATE' | translate"
      fieldId="due_date_field"
      e2eId="due-date-field"
      [horizontalAlignment]="datePickerHorizontalAlignment"
      [formControl]="form.get(formKeys.DUE_DATE)"
      [options]="dueDateOptions"
    >
    </app-date-picker-field>
  </div>
</div>

<div class="summary-calculations aside-section">
  <div class="calculation-field form-row">
    <span class="calculation-label">
      {{ 'LABEL.SUBTOTAL' | translate }}
    </span>

    <span class="amount">
      {{ documentCalculationResult?.subTotal | money: currencyCode:locale }}
    </span>
  </div>

  <div *ngIf="enableDiscount" class="calculation-field form-row editable-field">
    <label
      class="calculation-label editable-label"
      for="document_discount_action"
    >
      {{ 'LABEL.DISCOUNT' | translate }}
    </label>

    <button
      id="document_discount_action"
      type="button"
      class="editable-action amount"
      [ngClass]="{ 'dialog-opened': discountDialogOpened }"
      (click)="showDiscountDialog()"
      trackable
      [trackingObject]="trackingObject"
      [trackingAction]="editDiscountAction"
    >
      {{
        documentCalculationResult?.totalDiscount | money: currencyCode:locale
      }}
    </button>
  </div>
</div>

<div
  *ngIf="documentWithholdingTax?.enabled || taxSummary?.size > 0"
  class="taxes aside-section"
>
  <div
    *ngIf="documentWithholdingTax?.enabled"
    class="form-row withholding-tax-wrapper"
  >
    <div class="calculation-field">
      <span class="calculation-label">
        {{ documentWithholdingTax.name }}
      </span>
    </div>

    <div class="sub-label">
      <span class="tax-description">
        {{ documentWithholdingTax.rate | percentage: locale:3 }}
        {{ 'LABEL.OF' | translate }}
        {{
          documentCalculationResult?.subtotalWithholding
            | money: currencyCode:locale
        }}
      </span>

      <span class="ammount">
        {{
          documentCalculationResult?.totalWithholding
            | money: currencyCode:locale
        }}
      </span>
    </div>
  </div>

  <div *ngIf="taxSummary && !taxSummary.isEmpty()" class="tax-groups-wrapper">
    <div *ngFor="let taxGroup of taxSummary" class="form-row">
      <div class="calculation-field">
        <span class="calculation-label">
          {{ taxGroup.info.name }}
          ({{
            (taxGroup.info.inclusive
              ? 'LABEL.INCLUSIVE_ABBREVIATED'
              : 'LABEL.EXCLUSIVE_ABBREVIATED'
            ) | translate
          }})
        </span>

        <button
          type="button"
          class="edit-tax-action"
          trackable
          [trackingObject]="trackingObject"
          [trackingAction]="editTaxAction"
          (click)="showEditTaxDialog(taxGroup.info)"
        >
          {{ 'ACTION.EDIT' | translate }}
        </button>
      </div>

      <div *ngFor="let tax of taxGroup.taxTotals" class="sub-label">
        <span class="tax-description">
          {{ tax.rate | percentage: locale:3 }}
          {{ 'LABEL.OF' | translate }}
          {{ tax.subTotal | money: currencyCode:locale }}
        </span>

        <span class="ammount">
          {{ tax.total | money: currencyCode:locale }}
        </span>
      </div>
    </div>
  </div>
</div>

<div class="totals aside-section">
  <div
    *ngIf="documentSettings?.showShipping && enableShipping"
    class="calculation-field form-row editable-field"
  >
    <label class="calculation-label editable-label" for="shipping_action">
      {{ 'LABEL.SHIPPING' | translate }}
    </label>

    <button
      id="shipping_action"
      type="button"
      class="editable-action amount"
      [ngClass]="{ 'dialog-opened': shippingInfoDialogOpened }"
      trackable
      [trackingObject]="trackingObject"
      [trackingAction]="editShippingAction"
      (click)="showShippingInfoDialog()"
    >
      {{ documentShipping?.amount | money: currencyCode:locale }}
    </button>
  </div>

  <app-document-balance-breakdown
    [documentCalculationResult]="documentCalculationResult"
    [currencyCode]="currencyCode"
    [locale]="locale"
    [showTotal]="showTotal"
    [useOutstandingBalance]="useOutstandingBalance"
    [showPaid]="showPaid"
  >
  </app-document-balance-breakdown>
</div>

<div
  *ngIf="
    enableDeposits &&
    documentCalculationResult &&
    (depositRequestAllAccess || depositRequestReadAccess || !!deposit)
  "
  class="aside-section"
>
  <app-add-deposit-request
    class="add-deposit-request"
    [documentCalculationResult]="documentCalculationResult"
    [deposit]="deposit"
    [addDepositForFuture]="addDepositForFuture"
    [documentLocale]="documentSettings?.locale"
    [documentType]="documentType"
    [trackingScreenName]="trackingScreenName"
    [documentSettings]="documentSettings"
    [documentTrackingObject]="trackingObject"
    [depositRequestAllAccess]="depositRequestAllAccess"
    [depositRequestReadAccess]="depositRequestReadAccess"
    [document]="document"
    [documentAllAccess]="documentAllAccess"
    [depositRequestFeatureName]="depositRequestFeatureName"
    [documentDueDate]="documentDueDate"
    [featureToggles]="featureToggles"
    [account]="account"
    [paymentsSettings]="paymentsSettings"
    [enablePaidState]="documentType === DocumentTypesEnum.estimate"
    (onSaveDepositRequest)="saveDepositRequest($event)"
    (onRemoveDepositRequest)="removeDepositRequest()"
    (onDepositDisabledDialogClose)="onDepositDisabledDialogClose($event)"
    (onDepositDialogPreventOpen)="onDepositDialogPreventOpen()"
    (onUpdateDepositToggleSettings)="onUpdateSettingsContent.emit($event)"
  >
  </app-add-deposit-request>
</div>

<app-confirm-dialog
  [dialogId]="documentNumberChangeDialogId"
  [confirmPrompt]="
    'DIALOG.DOCUMENT_NUMBER_CHANGE.' + documentType | uppercase | translate
  "
  (onClose)="onDocumentNumberChangeConfirmClose($event)"
>
</app-confirm-dialog>

<app-document-discount-dialog
  (onUpdateDiscount)="updateDiscount($event)"
></app-document-discount-dialog>

<app-edit-tax-dialog (onUpdateTax)="updateTax($event)"></app-edit-tax-dialog>

<app-turn-on-payments-dialog
  [feesDescription]="paymentsSettings?.cardFeesDescription"
  [trackingScreenName]="trackingScreenName"
  (onTurnOnPayments)="turnOnPayments()"
>
</app-turn-on-payments-dialog>

<app-onboarding-stripe-dialog
  [underwritingUrl]="underwritingUrl$ | async"
  [trackingScreenName]="trackingScreenName"
>
</app-onboarding-stripe-dialog>
